import React, { useEffect, useState, useCallback } from 'react';
import { FaTools, FaCoffee, FaLaptopCode, FaGithub, FaServer, FaDna, FaBrain, FaAtom, FaSatelliteDish, FaMicrochip } from 'react-icons/fa';
import { GiNinjaMask, GiGameConsole, GiArtificialIntelligence, GiCyberEye, GiBlackHoleBolas, GiProcessor, GiCircuitry, GiPowerButton } from 'react-icons/gi';
import { IoRocketSharp, IoServerOutline, IoPlanetOutline } from 'react-icons/io5';
import { BsGearFill, BsEmojiWinkFill, BsCircuitBoard, BsCpu, BsTerminal } from 'react-icons/bs';
import { RiAliensFill, RiRobot2Fill, RiSpaceShipFill, RiQuestionMark } from 'react-icons/ri';
import { LuCircuitBoard, LuBrainCircuit } from "react-icons/lu";
import { TbBinaryTree2, TbCircuitCapacitor, TbCircuitCell } from "react-icons/tb";
// import './Developing.css';

import styled from 'styled-components';


// Copy-paste your CSS directly here
const StyledWrapper = styled.div`

 /* Base container */
.developing-container {
    min-height: 100vh;
    background: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    color: #00ff9d;
    overflow: hidden;
    position: relative;
  }
  
  /* Matrix-like background effect */
  .developing-container::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(0deg, 
      rgba(0, 255, 157, 0.03) 25%, 
      transparent 25%,
      transparent 50%, 
      rgba(0, 255, 157, 0.03) 50%, 
      rgba(0, 255, 157, 0.03) 75%, 
      transparent 75%, 
      transparent
    );
    background-size: 4px 4px;
    opacity: 0.3;
    animation: matrix-bg 20s linear infinite;
    pointer-events: none;
  }
  
  /* Grid overlay effect */
  .developing-container::after {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: 
      linear-gradient(90deg, rgba(0, 255, 157, 0.03) 1px, transparent 1px) 0 0,
      linear-gradient(rgba(0, 255, 157, 0.03) 1px, transparent 1px) 0 0;
    background-size: 20px 20px;
    animation: grid-movement 15s linear infinite;
    pointer-events: none;
  }
  
  .content-wrapper {
    width: 100%;
    max-width: 800px;
    padding: 2rem;
    position: relative;
    z-index: 1;
  }
  
  /* Scanning line effect */
  .content-wrapper::before {
    content: '';
    position: absolute;
    top: -100%;
    left: 0;
    width: 100%;
    height: 10px;
    background: linear-gradient(90deg, 
      transparent,
      rgba(0, 255, 157, 0.2),
      rgba(0, 255, 157, 0.4),
      rgba(0, 255, 157, 0.2),
      transparent
    );
    animation: scanning-line 3s linear infinite;
    pointer-events: none;
  }
  
  /* Enhanced floating elements */
  .floating-items {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
  
  .floating-gear {
    position: absolute;
    color: rgba(0, 255, 157, 0.15);
    z-index: 0;
    filter: drop-shadow(0 0 10px rgba(0, 255, 157, 0.3));
  }
  
  .floating-ship {
    position: absolute;
    color: rgba(0, 255, 255, 0.15);
    font-size: 3rem;
    animation: space-float 15s ease-in-out infinite;
    filter: drop-shadow(0 0 15px rgba(0, 255, 255, 0.3));
  }
  
  .floating-alien {
    position: absolute;
    color: rgba(255, 159, 28, 0.15);
    font-size: 2.5rem;
    animation: space-float 12s ease-in-out infinite reverse;
    filter: drop-shadow(0 0 15px rgba(255, 159, 28, 0.3));
  }
  
  /* Positioning floating elements */
  .gear1 {
    top: 10%;
    left: 10%;
    font-size: 4rem;
    animation: float-spin 8s ease-in-out infinite;
  }
  
  .gear2 {
    top: 60%;
    right: 15%;
    font-size: 6rem;
    animation: float-spin 10s ease-in-out infinite reverse;
  }
  
  .gear3 {
    bottom: 10%;
    left: 30%;
    font-size: 5rem;
    animation: float-spin 12s ease-in-out infinite;
  }
  
  .ship1 {
    top: 20%;
    right: 25%;
    animation: space-cruise 20s linear infinite;
  }
  
  .alien1 {
    bottom: 25%;
    right: 10%;
    animation: alien-float 15s ease-in-out infinite;
  }
  
  /* Holographic main content */
  .main-content {
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    padding: 2rem;
    text-align: center;
    box-shadow: 
      0 0 20px rgba(0, 255, 157, 0.1),
      0 0 40px rgba(0, 255, 157, 0.05),
      inset 0 0 20px rgba(0, 255, 157, 0.05);
    border: 1px solid rgba(0, 255, 157, 0.1);
    position: relative;
    overflow: hidden;
  }
  
  /* Holographic scan lines */
  .main-content::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: repeating-linear-gradient(
      transparent 0%,
      rgba(0, 255, 157, 0.05) 0.5px,
      transparent 1px,
      transparent 4px
    );
    animation: scan-lines 10s linear infinite;
    pointer-events: none;
  }
  
  /* Glowing border effect */
  .main-content::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 20px;
    border: 1px solid rgba(0, 255, 157, 0.3);
    box-shadow: 
      0 0 20px rgba(0, 255, 157, 0.2),
      inset 0 0 20px rgba(0, 255, 157, 0.2);
    animation: glow-pulse 4s ease-in-out infinite;
    pointer-events: none;
  }
  
  .icon-container {
    margin-bottom: 2rem;
    position: relative;
    display: flex;
    justify-content: center;
    gap: 1rem;
  }
  
  .tools-icon {
    font-size: 4rem;
    color: #00ff9d;
    filter: drop-shadow(0 0 10px rgba(0, 255, 157, 0.5));
  }
  
  .ninja-icon {
    font-size: 3rem;
    color: #ff6b6b;
    filter: drop-shadow(0 0 10px rgba(255, 107, 107, 0.5));
  }
  
  .ai-icon {
    font-size: 3.5rem;
    color: #00ffff;
    filter: drop-shadow(0 0 10px rgba(0, 255, 255, 0.5));
  }
  
  .title {
    font-size: 2.5rem;
    margin-bottom: 2rem;
    text-shadow: 
      0 0 10px rgba(0, 255, 157, 0.5),
      0 0 20px rgba(0, 255, 157, 0.3),
      0 0 30px rgba(0, 255, 157, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
  }
  
  .loading-text {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    font-size: 1.5rem;
    margin-bottom: 2rem;
    text-shadow: 0 0 10px rgba(0, 255, 157, 0.5);
  }
  
  /* Enhanced message box */
  .message-box {
    background: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    padding: 1.5rem;
    margin-bottom: 2rem;
    position: relative;
    border: 1px solid rgba(0, 255, 157, 0.2);
    overflow: hidden;
  }
  
  /* Holographic message effect */
  .message-box::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
      circle at center,
      rgba(0, 255, 157, 0.1) 0%,
      transparent 70%
    );
    animation: holo-rotate 10s linear infinite;
  }
  
  .message-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    font-size: 1.1rem;
    position: relative;
    z-index: 1;
  }
  
  .message-wrapper svg {
    font-size: 1.5rem;
    color: #00ffff;
    filter: drop-shadow(0 0 5px rgba(0, 255, 255, 0.5));
  }
  
  /* Status items with hover effect */
  .status-item {
    display: flex;
    align-items: center;
    gap: 1rem;
    font-size: 1.1rem;
    padding: 0.8rem;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(0, 255, 157, 0.1);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }
  
  .status-item::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(0, 255, 157, 0.1),
      transparent
    );
    transition: 0.5s;
  }
  
  .status-item:hover::before {
    left: 100%;
  }
  
  .status-item:hover {
    background: rgba(0, 255, 157, 0.1);
    transform: translateX(5px);
  }
  
  /* Icon colors with glow effects */
  .coffee-icon { 
    color: #ff9f1c;
    filter: drop-shadow(0 0 5px rgba(255, 159, 28, 0.5));
  }
  
  .game-icon { 
    color: #ff6b6b;
    filter: drop-shadow(0 0 5px rgba(255, 107, 107, 0.5));
  }
  
  .rocket-icon { 
    color: #00ff9d;
    filter: drop-shadow(0 0 5px rgba(0, 255, 157, 0.5));
  }
  
  .alien-icon { 
    color: #00ffff;
    filter: drop-shadow(0 0 5px rgba(0, 255, 255, 0.5));
  }
  
  .footer {
    border-top: 1px solid rgba(0, 255, 157, 0.1);
    padding-top: 1rem;
    font-size: 0.9rem;
    position: relative;
    overflow: hidden;
  }
  
  .footer::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(0, 255, 157, 0.5),
      transparent
    );
    animation: border-glow 3s ease-in-out infinite;
  }
  
  /* Enhanced Animations */
  @keyframes matrix-bg {
    0% { background-position: 0 0; }
    100% { background-position: 0 100%; }
  }
  
  @keyframes grid-movement {
    0% { transform: translateZ(0); }
    100% { transform: translate3d(-20px, -20px, 0); }
  }
  
  @keyframes scanning-line {
    0% { transform: translateY(0); }
    100% { transform: translateY(1000%); }
  }
  
  @keyframes float-spin {
    0% { transform: translateY(0) rotate(0deg); }
    50% { transform: translateY(-20px) rotate(180deg); }
    100% { transform: translateY(0) rotate(360deg); }
  }
  
  @keyframes space-cruise {
    0% { 
      transform: translate(0, 0) rotate(0deg); 
      opacity: 0;
    }
    10% { opacity: 1; }
    90% { opacity: 1; }
    100% { 
      transform: translate(-1000px, 100px) rotate(-45deg);
      opacity: 0;
    }
  }
  
  @keyframes alien-float {
    0% { transform: translate(0, 0) rotate(0deg) scale(1); }
    25% { transform: translate(-20px, -15px) rotate(5deg) scale(1.1); }
    50% { transform: translate(0, -30px) rotate(0deg) scale(1); }
    75% { transform: translate(20px, -15px) rotate(-5deg) scale(0.9); }
    100% { transform: translate(0, 0) rotate(0deg) scale(1); }
  }
  
  @keyframes scan-lines {
    0% { transform: translateY(0); }
    100% { transform: translateY(100px); }
  }
  
  @keyframes glow-pulse {
    0%, 100% { opacity: 0.5; }
    50% { opacity: 1; }
  }
  
  @keyframes holo-rotate {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  @keyframes border-glow {
    0%, 100% { opacity: 0.3; }
    50% { opacity: 1; }
  }
  
  /* Animation utility classes */
  .rotating { animation: spin 8s linear infinite; }
  .bouncing { animation: bounce 2s ease-in-out infinite; }
  .bounce-slow { animation: bounce 3s ease-in-out infinite; }
  .pulse { animation: glow-pulse 2s ease-in-out infinite; }
  
  /* Responsive design */
  @media (max-width: 768px) {
    .content-wrapper {
      padding: 1rem;
    }
  
    .title {
      font-size: 1.8rem;
    }
  
    .loading-text {
      font-size: 1.2rem;
    }
  
    .message-wrapper {
      flex-direction: column;
      text-align: center;
    }
  
    .floating-gear {
      font-size: 2.5rem;
    }
  
    .floating-ship,
    .floating-alien {
      font-size: 2rem;
    }
  }
  
 /* Additional hover effects */
.main-content:hover::after {
    animation: glow-pulse 1s ease-in-out infinite;
    border-color: rgba(0, 255, 157, 0.5);
  }
  
  /* Cyberpunk glitch effect on hover */
  .title:hover {
    animation: glitch 1s steps(2, start) infinite;
    position: relative;
  }
  
  .title:hover::before,
  .title:hover::after {
    content: attr(data-text);
    position: absolute;
    left: 0;
    text-shadow: 1px 0 #00ffff;
    width: 100%;
    clip: rect(44px, 450px, 56px, 0);
    animation: glitch-anim 5s infinite linear alternate-reverse;
  }
  
  .title:hover::before {
    text-shadow: -1px 0 #ff0000;
    animation: glitch-anim-2 1s infinite linear alternate-reverse;
    left: 2px;
  }
  
  /* Neon text effect for status items */
  .status-item:hover span {
    animation: neon-text-flicker 0.2s ease-in-out infinite alternate;
  }
  
  /* Energy field effect around icons */
  .tools-icon:hover,
  .ninja-icon:hover,
  .ai-icon:hover {
    animation: energy-field 2s ease-in-out infinite;
  }
  
  /* Holographic ripple effect */
  .message-box:hover::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
      circle at center,
      rgba(0, 255, 157, 0.2) 0%,
      transparent 50%
    );
    transform: translate(-50%, -50%);
    animation: ripple 2s ease-out infinite;
  }
  
  /* Enhanced loading animation */
  .loading-text:hover span {
    animation: cyber-loading 2s steps(4) infinite;
  }
  
  /* Additional Keyframe Animations */
  @keyframes glitch {
    0% { transform: translate(0); }
    20% { transform: translate(-2px, 2px); }
    40% { transform: translate(-2px, -2px); }
    60% { transform: translate(2px, 2px); }
    80% { transform: translate(2px, -2px); }
    100% { transform: translate(0); }
  }
  
  @keyframes glitch-anim {
    0% {
      clip: rect(31px, 9999px, 94px, 0);
      transform: skew(0.85deg);
    }
    5% {
      clip: rect(8px, 9999px, 51px, 0);
      transform: skew(0.17deg);
    }
    10% {
      clip: rect(32px, 9999px, 73px, 0);
      transform: skew(0.89deg);
    }
    15% {
      clip: rect(90px, 9999px, 85px, 0);
      transform: skew(0.36deg);
    }
    20% {
      clip: rect(20px, 9999px, 59px, 0);
      transform: skew(0.05deg);
    }
    25% {
      clip: rect(77px, 9999px, 57px, 0);
      transform: skew(0.43deg);
    }
  }
  
  @keyframes glitch-anim-2 {
    0% {
      clip: rect(65px, 9999px, 119px, 0);
      transform: skew(0.12deg);
    }
    5% {
      clip: rect(34px, 9999px, 61px, 0);
      transform: skew(0.67deg);
    }
    10% {
      clip: rect(89px, 9999px, 46px, 0);
      transform: skew(0.95deg);
    }
  }
  
  @keyframes neon-text-flicker {
    0%, 19.999%, 22%, 62.999%, 64%, 64.999%, 70%, 100% {
      opacity: 1;
      text-shadow: 
        0 0 4px #fff,
        0 0 11px #fff,
        0 0 19px #fff,
        0 0 40px #00ff9d,
        0 0 80px #00ff9d,
        0 0 90px #00ff9d,
        0 0 100px #00ff9d,
        0 0 150px #00ff9d;
    }
    20%, 21.999%, 63%, 63.999%, 65%, 69.999% {
      opacity: 0.4;
      text-shadow: none;
    }
  }
  
  @keyframes energy-field {
    0% {
      filter: drop-shadow(0 0 5px currentColor) 
              drop-shadow(0 0 10px currentColor)
              drop-shadow(0 0 15px currentColor);
    }
    50% {
      filter: drop-shadow(0 0 10px currentColor)
              drop-shadow(0 0 20px currentColor)
              drop-shadow(0 0 30px currentColor);
    }
    100% {
      filter: drop-shadow(0 0 5px currentColor)
              drop-shadow(0 0 10px currentColor)
              drop-shadow(0 0 15px currentColor);
    }
  }
  
  @keyframes ripple {
    0% {
      transform: translate(-50%, -50%) scale(0);
      opacity: 1;
    }
    100% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 0;
    }
  }
  
  @keyframes cyber-loading {
    0% { content: "Loading"; }
    25% { content: "L0ading"; }
    50% { content: "Load1ng"; }
    75% { content: "L0ad1ng"; }
    100% { content: "Loading"; }
  }
  
  /* Sci-fi interface elements */
  .interface-scanner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: rgba(0, 255, 157, 0.5);
    box-shadow: 
      0 0 10px rgba(0, 255, 157, 0.5),
      0 0 20px rgba(0, 255, 157, 0.3),
      0 0 30px rgba(0, 255, 157, 0.1);
    animation: interface-scan 2s linear infinite;
  }
  
  @keyframes interface-scan {
    0% { transform: translateY(-100%); }
    100% { transform: translateY(1000%); }
  }
  
  /* Data stream effect */
  .data-stream {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 0;
  }
  
  .data-particle {
    position: absolute;
    width: 1px;
    height: 1px;
    background: rgba(0, 255, 157, 0.5);
    box-shadow: 0 0 5px rgba(0, 255, 157, 0.5);
    animation: data-fall linear infinite;
  }
  
  @keyframes data-fall {
    0% { 
      transform: translateY(-100vh);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% { 
      transform: translateY(100vh);
      opacity: 0;
    }
  }
  
  /* Circuit board pattern overlay */
  .circuit-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: 
      linear-gradient(90deg, rgba(0, 255, 157, 0.05) 1px, transparent 1px) 0 0,
      linear-gradient(rgba(0, 255, 157, 0.05) 1px, transparent 1px) 0 0;
    background-size: 20px 20px;
    pointer-events: none;
    animation: circuit-move 20s linear infinite;
  }
  
  @keyframes circuit-move {
    0% { transform: translate(0, 0); }
    100% { transform: translate(20px, 20px); }
  }

  /* Matrix rain effect */
.matrix-character {
    position: fixed;
    color: #00ff9d;
    font-family: 'Courier New', monospace;
    font-size: 14px;
    font-weight: bold;
    pointer-events: none;
    text-shadow: 0 0 8px rgba(0, 255, 157, 0.8);
    z-index: 0;
  }
  
  /* Circuit lines */
  .circuit-line {
    position: absolute;
    background: linear-gradient(90deg, 
      transparent,
      rgba(0, 255, 157, 0.2),
      rgba(0, 255, 157, 0.5),
      rgba(0, 255, 157, 0.2),
      transparent
    );
    height: 1px;
    width: 100px;
    animation: circuit-pulse var(--duration) ease-in-out infinite;
    animation-delay: var(--delay);
    transform-origin: left center;
  }
  
  .circuit-node {
    position: absolute;
    color: #00ff9d;
    font-size: 12px;
    animation: node-pulse 2s ease-in-out infinite;
  }
  
  /* System diagnostics */
  .system-diagnostics {
    display: flex;
    justify-content: space-around;
    margin: 1rem 0;
    padding: 1rem;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    border: 1px solid rgba(0, 255, 157, 0.2);
  }
  
  .diagnostic-item {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  
  .diagnostic-icon {
    font-size: 1.5rem;
    color: #00ff9d;
    animation: diagnostic-pulse 2s ease-in-out infinite;
  }
  
  .diagnostic-bar {
    width: 100px;
    height: 4px;
    background: rgba(0, 255, 157, 0.2);
    border-radius: 2px;
    overflow: hidden;
    position: relative;
  }
  
  .diagnostic-bar::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: var(--progress);
    background: #00ff9d;
    box-shadow: 0 0 10px #00ff9d;
    animation: progress-pulse 2s ease-in-out infinite;
  }
  
  .diagnostic-text {
    font-family: 'Courier New', monospace;
    color: #00ff9d;
    text-shadow: 0 0 5px rgba(0, 255, 157, 0.5);
    animation: text-flicker 0.3s ease-in-out infinite;
  }
  
  .diagnostic-code {
    font-family: 'Courier New', monospace;
    color: #00ff9d;
    animation: code-change 0.5s ease;
  }
`;


const Developing = () => {
  const [loadingDots, setLoadingDots] = useState('');
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [matrixCharacters, setMatrixCharacters] = useState([]);
  const [powerLevel, setPowerLevel] = useState(0);
  const [systemStatus, setSystemStatus] = useState('INITIALIZING');
  const [glitchText, setGlitchText] = useState(false);
  const [particleCount, setParticleCount] = useState(0);

  // Matrix rain effect
  useEffect(() => {
    const chars = '01';
    const newMatrix = Array.from({ length: 50 }, () => ({
      char: chars[Math.floor(Math.random() * chars.length)],
      x: Math.random() * window.innerWidth,
      y: Math.random() * window.innerHeight,
      speed: 1 + Math.random() * 3,
      opacity: Math.random()
    }));
    setMatrixCharacters(newMatrix);

    const interval = setInterval(() => {
      setMatrixCharacters(prev => prev.map(item => ({
        ...item,
        y: item.y > window.innerHeight ? 0 : item.y + item.speed,
        char: Math.random() > 0.95 ? chars[Math.floor(Math.random() * chars.length)] : item.char,
        opacity: Math.random()
      })));
    }, 50);

    return () => clearInterval(interval);
  }, []);

  // Power level animation
  useEffect(() => {
    const powerInterval = setInterval(() => {
      setPowerLevel(prev => (prev + 1) % 101);
    }, 100);

    return () => clearInterval(powerInterval);
  }, []);

  // System status cycling
  useEffect(() => {
    const statuses = ['INITIALIZING', 'SCANNING','ANALYZING', 'OPTIMIZING'];
    let index = 0;

    const statusInterval = setInterval(() => {
      index = (index + 1) % statuses.length;
      setSystemStatus(statuses[index]);
    }, 3000);

    return () => clearInterval(statusInterval);
  }, []);

  // Loading dots animation
  useEffect(() => {
    const dotsInterval = setInterval(() => {
      setLoadingDots(dots => dots.length >= 3 ? '' : dots + '.');
    }, 500);

    return () => clearInterval(dotsInterval);
  }, []);

  // Message rotation
  useEffect(() => {
    const messageInterval = setInterval(() => {
      setCurrentMessageIndex(prev => (prev + 1) % funnyMessages.length);
    }, 3000);

    return () => clearInterval(messageInterval);
  }, []);

  // Particle generator
  useEffect(() => {
    const particleInterval = setInterval(() => {
      setParticleCount(prev => (prev + 1) % 1000);
    }, 100);

    return () => clearInterval(particleInterval);
  }, []);

  // Glitch text effect
  useEffect(() => {
    const glitchInterval = setInterval(() => {
      setGlitchText(true);
      setTimeout(() => setGlitchText(false), 200);
    }, 5000);

    return () => clearInterval(glitchInterval);
  }, []);

  const funnyMessages = [
    { text: "Initializing quantum processors", icon: <GiArtificialIntelligence />, color: "#00ff9d" },
    { text: "Teaching AI to appreciate cat memes", icon: <RiRobot2Fill />, color: "#ff6b6b" },
    { text: "Debugging parallel universe conflicts", icon: <RiAliensFill />, color: "#00ffff" },
    { text: "Converting caffeine into neural algorithms", icon: <FaBrain />, color: "#ff9f1c" },
    { text: "Negotiating with stubborn semicolons", icon: <GiCyberEye />, color: "#ff00ff" },
    { text: "Downloading more RAM (still waiting...)", icon: <FaServer />, color: "#00ff9d" },
    { text: "Recalibrating the space-time compiler", icon: <RiSpaceShipFill />, color: "#ff6b6b" },
    { text: "Teaching robots TikTok dances", icon: <GiBlackHoleBolas/>, color: "#00ffff" },
    { text: "Untangling quantum spaghetti code", icon: <FaDna />, color: "#ff9f1c" },
    { text: "Asking ChatGPT to solve P vs NP", icon: <LuCircuitBoard />, color: "#ff00ff" },
    { text: "Optimizing neural pathways", icon: <LuBrainCircuit />, color: "#00ff9d" },
    { text: "Compiling thoughts into binary", icon: <TbBinaryTree2 />, color: "#ff6b6b" },
    { text: "Charging quantum capacitors", icon: <TbCircuitCapacitor />, color: "#00ffff" },
    { text: "Synchronizing parallel processes", icon: <GiProcessor />, color: "#ff9f1c" },
    { text: "Connecting to alien APIs", icon: <FaSatelliteDish />, color: "#ff00ff" }
  ];

  const statusUpdates = [
    {
      icon: <FaCoffee className="coffee-icon bounce-slow" />,
      text: "Neural Fuel (Coffee) Level: ∞",
      subText: `Power Output: ${powerLevel}%`
    },
    {
      icon: <GiGameConsole className="game-icon pulse" />,
      text: "Mandatory VR Debugging Session™",
      subText: `Active Sessions: ${Math.floor(Math.random() * 100)}`
    },
    {
      icon: <IoRocketSharp className="rocket-icon" />,
      text: "Progress: Breaking Speed of Light",
      subText: `Particle Count: ${particleCount}`
    },
    {
      icon: <RiAliensFill className="alien-icon rotating" />,
      text: "Extraterrestrial Code Reviews: Pending",
      subText: `Signal Strength: ${Math.floor(Math.random() * 100)}%`
    }
  ];

  const generateHexCode = () => {
    return '#' + Math.floor(Math.random()*16777215).toString(16);
  };

  const renderMatrixRain = () => {
    return matrixCharacters.map((item, index) => (
      <div
        key={index}
        className="matrix-character"
        style={{
          left: item.x,
          top: item.y,
          opacity: item.opacity,
        }}
      >
        {item.char}
      </div>
    ));
  };

  const renderCircuitLines = () => {
    return Array.from({ length: 10 }).map((_, index) => (
      <div
        key={index}
        className="circuit-line"
        style={{
          '--duration': `${Math.random() * 5 + 2}s`,
          '--delay': `${Math.random() * 2}s`
        }}
      >
        <TbCircuitCell className="circuit-node" />
      </div>
    ));
  };

  const renderSystemDiagnostics = () => {
    return (
      <div className="system-diagnostics">
        <div className="diagnostic-item">
          <BsCpu className="diagnostic-icon" />
          <div className="diagnostic-bar" style={{ '--progress': `${powerLevel}%` }} />
        </div>

        
        <div className="diagnostic-item">
          <GiCircuitry className="diagnostic-icon" />
          <div className="diagnostic-text">{systemStatus}</div>
        </div>

        
        <div className="diagnostic-item">
          <BsTerminal className="diagnostic-icon" />
          <div className="diagnostic-code">{generateHexCode()}</div>
        </div>
      </div>
    );
  };

  return (
    <StyledWrapper>
    <div className="developing-container">
      {renderMatrixRain()}
      <div className="content-wrapper">
        <div className="floating-items">
          <BsGearFill className="floating-gear gear1" />
          <BsGearFill className="floating-gear gear2" />
          <BsGearFill className="floating-gear gear3" />
          <RiSpaceShipFill className="floating-ship ship1" />
          <RiAliensFill className="floating-alien alien1" />
          <FaAtom className="floating-atom atom1" />
          <FaMicrochip className="floating-chip chip1" />
        </div>

        {renderCircuitLines()}

        <div className="main-content">
          <div className="power-button">
            <GiPowerButton className="power-icon pulse" />
          </div>

          <div className="icon-container">
            <FaTools className="tools-icon rotating" />
            <GiNinjaMask className="ninja-icon bouncing" />
            <GiArtificialIntelligence className="ai-icon pulse" />
          </div>

          <h1 className={`title ${glitchText ? 'glitch' : ''}`}>
            <RiRobot2Fill className="title-icon" />
            System Upgrade In Progress
            <RiRobot2Fill className="title-icon" />
          </h1>

          {renderSystemDiagnostics()}

          <div className="loading-text">
            <FaLaptopCode className="laptop-icon" />
            <span className="cyber-text">Compiling Future{loadingDots}</span>
          </div>

          <div className="message-box hologram">
            <div className="scan-line"></div>
            <div className="message-wrapper" style={{ color: funnyMessages[currentMessageIndex].color }}>
              {funnyMessages[currentMessageIndex].icon}
              <p className="funny-message">
                {funnyMessages[currentMessageIndex].text}
              </p>
            </div>
          </div>

          <div className="developer-status">
            {statusUpdates.map((status, index) => (
              <div key={index} className="status-item">
                {status.icon}
                <div className="status-content">
                  <span className="status-text">{status.text}</span>
                  <span className="status-subtext">{status.subText}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="footer">
            <p className="quantum-text">
              <BsEmojiWinkFill className="wink-icon pulse" />
              Probability of completion: √-1%
            </p>
            <div className="github-link">
              <FaGithub className="github-icon rotating" />
              <span>Committing code across dimensions</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    </StyledWrapper>
  );
};

export default Developing;
